// 转介绍邀请js
(function () {

  // 邮箱
  var email = '';
  // 分页相关参数
  var pageCount = 1; // 当前页数
  var count = 20; // 每页请求数量，默认值10，最大值2000
  var lastId = ''; // 每页请求的最后Id
  var hasMore = false; // 是否可加载更多
  var isLoading = false; // 是否在loading
  var registerUserInfo = null;

  var inviteCouponListHtml = `
    <div class="my-coupon-list">
      <div class="coupon-list-header">
        <p><%t('refer.page.table_header_date') %></p>
        <p><%t('refer.page.table_header_code') %></p>
        <p><%t('refer.page.table_header_friend') %></p>
        <p><%t('refer.page.table_header_reward') %></p>
        <p><%t('refer.page.table_header_status') %></p>
      </div>
      <div class="coupon-list-content">
        <% for ( var item of data ) { %>
          <div class="coupon-li">
            <p class="p1"><%= LS.formatTime(item.inviteTime, 'MM/dd/yyyy') %></p>
            <p class="p1 gray"><% if (item.status == 2){ %><%= item.code %><% } %></p>
            <p class="p1"><%= item.email %></p>
            <p class="p1 <% if (item.status != 2) { %>gray<% } %>">A $20 Coupon</p>
            <% if (item.status == 1) { %>
              <p class="p1 red"><%t('refer.page.table_status_pending') %></p>
            <% } else if (item.status == 2) { %>
              <p class="p1 green"><%t('refer.page.table_status_succ') %></p>
            <% } else if (item.status == 3) { %>
              <p class="p1 gray"><%t('refer.page.table_status_expired') %></p>
            <% } else if (item.status == 4) { %>
              <p class="p1 gray"><%t('refer.page.table_status_failed') %></p>
            <% } %>
          </div>
        <% } %>
      </div>
    </div>
  `;

  // 成功弹窗
  var sendSuccPopHtml = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-refer">
      <div class="ls-vertical-popupbox-overlay"></div>
      <div class="ls-vertical-popupbox-con">
        <!-- 内容区域 -->
        <div class="con-modelbox">
          <!-- 删除区域 -->
          <div class="con-close-btn">
            <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-subscribe-pop-close.png?v=1658746066" />
          </div>
          <p class="p1">${LS.$t('refer.page.succ_pop_title')}</p>
          <p class="p2">${LS.$t('refer.page.succ_pop_subtext')}</p>
          <div class="con-modelbox-bot">
            <div class="ls-continue-to-refer">${LS.$t('refer.page.succ_pop_btn')}</div>
          </div>
        </div>
      </div>
    </div>
  `;

  // 个人中心推荐好友模块
  var referFriendPageHtml = `
    <div class="looksky-invite-box">
      <div class="invite-box-model">
        <div class="box-banner js-lazyload-img">
          <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_Refer_a_Friend_pc_2x_2_1400x.jpg?v=1678415150" />
        </div>
        <div class="box-content">
          <p class="p1">Refer & Earn</p>
          <p class="p2">*All are calculated in USD value</p>
          <div class="card-wrapper">
            <div class="card-item">
              <img class="card-icon" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_share_2x_6c68f42e-ae3f-469d-85d9-e5aea6e603f0.jpg?v=1678419691" />
              <div class="card-text">Refer a friend</div>
              <div class="card-text">via email or a link</div>
            </div>
            <div class="card-item">
              <img class="card-icon" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_account_2x_e9ae1939-6aca-4ce9-b72a-624b576f7af7.jpg?v=1678419692" />
              <div class="card-text">Friend registers for</div>
              <div class="card-text">the Grae Cove</div>
              <div class="card-text">Collective</div>
            </div>
            <div class="card-item">
              <img class="card-icon" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_coupons_2x_e90caf62-22eb-48a3-9104-30afbc2296d6.jpg?v=1678419692" />
              <div class="card-text">Both you and your</div>
              <div class="card-text">friend receive a</div>
              <div class="card-text">$20.00 coupon</div>
            </div>
          </div>
          <div class="send-inp-box">
            <div class='inp-wrapper'>
              <input class="email-inp inviter-email-inp" placeholder="Your email" />
              <div class="error-tip inviter-error-tip"></div>
            </div>
            <div class='inp-wrapper'>
              <input class="email-inp invitee-email-inp" placeholder="${LS.$t('refer.page.inp_placeholder')}" />
              <div class="error-tip invitee-error-tip"></div>
            </div>
            <p class="p2">${LS.$t('refer.page.inp_tip')}</p>
            <div class="ls-send-email" id="ls-send-email">${LS.$t('refer.page.inp_send_btn')}</div>
            <p class="tip">*When you refer-a-friend through the "Share the Grae Cove Love" program, we'll automatically enroll you to the Grae Cove Collective if you're not already registered. This account will help you track your invitations and manage your coupons, so you can enjoy all the benefits of being a Grae Cove Collective member hassle-free.</p>
          </div>
          <div class="refer-link-box">
            <img class="ls-link-btn" id="ls-link-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-invitation-share2.png?v=1659683807" />
            <p class="copy-text">Refer via a link</p>
          </div>
        </div>
      </div>
      <div class="box-referrals">
        <p class="title">${LS.$t('refer.page.table_title')}</p>
        <div class="row-box">
          <p class="p1 success-reward-num"></p>
          <p class="my-coupons-btn" id="my-coupons-btn"><a href="${LS.site.baseUrl}/pages/my?from=email_coupon">${LS.$t('refer.page.table_my_coupons_btn')}</a></p>
        </div>
        <div class="my-coupon-modelbox">
          <div class="my-coupon-nolist">
            <img class="no-list" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-no-list-img.png?v=1659606261" />
            <p class="p1">Refer list is empty…</p>
          </div>
        </div>
      </div>
    </div>
  `;

  // 邀请方法
  var inviteFn = {

    /**
     * 推荐列表滚动方法
     */
    getReferScroll: function () {
      // 滚动
      window.addEventListener("scroll", function (e) {
        // 当还在loading或者没有下一页时
        if ( isLoading || !hasMore ) {
          return;
        }
        // 视图滚动的高度
        var scrollH = $(window).scrollTop();
        // 视图的高度
        var contentH = $("body").height();
        // 差值（窗口滚动到这个差值的时候，加载下一页）视图高度+一半商品块的高度
        var differenceH = $(window).height() + 200;
        // 窗体的高度-滚动的高度
        var differH = contentH - scrollH;
        if (differH <= differenceH) {
          if (isLoading) {
            return;
          }
          isLoading = true;
          // 请求
          inviteFn.getReferList();
        }
      });
    },

    /**
     * 初始化请求
     */
    getReferList: function (reset = false) {
      // 调用接口
      LS.ajax({
        url: LS.ui.routes.inviteQueryUserReferralsPage,
        type: "GET",
        data: {
          lastId: lastId,
          count: count,
        },
        success: function (res) {
          if (!res.hasError && res.code == '0') {
            // 判断数组长度
            if (res.data && res.data.record && res.data.record.length > 0) {
              // 赋值
              hasMore = res.data.hasMore;
              lastId = res.data.lastId;
              reset && (pageCount = 1);
              var record = res.data.record;
              // 创建数据html
              var htmlStr = LS.tmpl(inviteCouponListHtml, record);

              var successList = record.filter(item => item.status === 2);
              $('.success-reward-num').text(`Accumulated rewards ${successList.length} coupons`);

              // 累积收益
              res.data.extraData && $(".accumulated-rewards-num").text(res.data.extraData.totalcoupons);
              if (pageCount == 1) {
                // 添加到页面
                $(".looksky-invite-box .my-coupon-modelbox").html(htmlStr);
              } else {
                // 添加到页面
                $(".looksky-invite-box .my-coupon-modelbox .coupon-list-content").append($(htmlStr).find('.coupon-list-content').html());
              }
              // 页数
              pageCount++;
              // 当没有下一页时
              if ( !res.data.hasMore ) {
                lastId = '';
                return;
              }
            }
          } else {
            LS.ui.toastShowHandle(res.error.message);
          }
        },
        complete: function () {
          isLoading = false;
        },
        error: function (error) {
          //  LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
		bindEvent: function () {
      $(document).on("click", ".looksky-invite-box #ls-link-btn", function () {
        var userId = LS.cookie.get('graecove_userid') || '';
        var userVipInfo = LS.userVipInfo || '';
        if (userVipInfo && userVipInfo.userBasicInfo) {
          var inviter = userVipInfo.userBasicInfo.firstName ? userVipInfo.userBasicInfo.firstName.replace(/\s*/g,"")+userVipInfo.userBasicInfo.lastName.replace(/\s*/g,"") : userVipInfo.userBasicInfo.email;
          var inviteUrl = `http://www.graecove.com${LS.site.dir}?inviter=${inviter}&inviterId=${userId}`;
        }
        var text = LS.$t('refer.page.copy-content_text') + inviteUrl;
        inviteUrl && LS.ui.copyToClip(text);
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.referReportMap['clickCopyReferLink'],
          ext2: inviteUrl,
        });
      })

      $('.looksky-invite-box .invitee-email-inp').on('keyup', function(e) {
        email = $(this).val();
      });

      $('.looksky-invite-box .invitee-email-inp').on('blur', function(e) {
        email = $(this).val();
      })
      
      $(document).on("click", ".ls-continue-to-refer,.ls-vertical-popupbox-refer .con-close-btn,.ls-vertical-popupbox-overlay", function () {
        // 删除弹窗
        $(this).parents(".ls-vertical-popupbox").remove();
        // 清除输入框内容
        $('.looksky-invite-box .invitee-email-inp').val('');
        email = '';
        // 恢复弹窗底部滚动方法
        LS.ui.popupRecoveryScrollHandle();
        if (registerUserInfo && !LS.ui.isLogin()) {
          LS.ui.handleUrlAndDataByLogin(registerUserInfo, location.href);
        }
      })

      // 点击my-coupon
      $(document).on("click", ".looksky-invite-box .my-coupons-btn", function () {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.referReportMap['clickMycoupons'],
        });
      })

      // 点击send
      var fristSend = true;
      $(document).on('click', '.looksky-invite-box .ls-send-email', function() {
        var emailList = email.replace(/\s*/g,"").split(',');
        // 查看输入邮箱是否正确
        var filterList = emailList.filter(item => LS.ui.validator.emailReg.test(item));
        var inviterEmail = $('.inviter-email-inp').val();
        if (!inviterEmail || !LS.ui.validator.emailReg.test(inviterEmail)) {
          $('.looksky-invite-box .inviter-error-tip').show().html(LS.$t('refer.page.inp_error4'));
          return;
        }
        // 判断是否填写了邮件
        if ( !email ) {
          // 显示为空错误信息
          $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error4'));
          // 上报
          inviteFn.inpEmailErrorReport($('.looksky-invite-box .invitee-error-tip').text());
          return false;
        } else if (emailList.length > 10) {
          // 提示限制长度
          $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error5'));
          // 上报
          inviteFn.inpEmailErrorReport($('.looksky-invite-box .invitee-error-tip').text());
          return false;
        } else if (emailList.length != filterList.length) {
          // 提示错误邮箱
          var _arr1 = emailList.filter(item => !filterList.includes(item));
          var str = _arr1.toString(',');
          $('.looksky-invite-box .invitee-error-tip').show().html(str + LS.$t('refer.page.inp_error3'));
          // 上报
          inviteFn.inpEmailErrorReport($('.looksky-invite-box .invitee-error-tip').text());
          return false;
        } else if (emailList.length == filterList.length) {
          // 清除错误信息
          $('.looksky-invite-box .invitee-error-tip').hide().html('');
          // 赋值
          var emailParams = emailList;
        }
        // 接口参数
        var params = JSON.stringify({
          emails: emailParams,
          inviteEmail: inviterEmail
        })
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.referReportMap['clickReferSendEmail'],
          ext2: params,
        });
        if (!fristSend) {
          return false;
        }
        fristSend = false;
        LS.ui.loadingBtnShow($('.ls-send-email'));
        LS.ajax({
          url: LS.ui.routes.inviteSendInvitedEmails,
          type: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          data: params,
          success: function(res) {
            // 接口成功
            if ( !res.hasError && res.code == "0" ) {
              // 判断提示文案
              if (res.data.notSupportEmails && res.data.notSupportEmails.length > 0) {
                $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error2'));
              } else if (res.data.notFirstOrderEmails.length > 0) {
                // 编写错误文案
                // 判断
                var notFirstOrderEmails = res.data.notFirstOrderEmails;
                if (notFirstOrderEmails.length == 1) {
                  var textEmail = notFirstOrderEmails.join();
                  $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error6', { textEmail: textEmail }));
                } else if (notFirstOrderEmails.length == 2) {
                  var textEmail = notFirstOrderEmails.join(' and ');
                  $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error6', { textEmail: textEmail }));
                } else if (notFirstOrderEmails.length > 2) {
                  var textEmail = notFirstOrderEmails[notFirstOrderEmails.length-1];
                  notFirstOrderEmails.splice(notFirstOrderEmails.length-1, 1);
                  var textEmail2 = notFirstOrderEmails.join(' , ');
                  $('.looksky-invite-box .invitee-error-tip').show().html(LS.$t('refer.page.inp_error1', { textEmail1: textEmail, textEmail2: textEmail2 }));
                }
              }
              if (res.data.notFirstOrderEmails.length != emailList.length && res.data.notSupportEmails.length === 0) {
                registerUserInfo = res.data.userLoginVo || null;
                // 创建弹窗
                $('body').append(sendSuccPopHtml);
                // 禁止弹窗底部滚动方法
                LS.ui.popupNoScrollHandle();
              } else {
                // 上报
                inviteFn.inpEmailErrorReport($('.looksky-invite-box .invitee-error-tip').text());
              }
              if (LS.ui.isLogin()) {
                pageCount = 1; // 当前页数
                lastId = ''; // 每页请求的最后Id
                inviteFn.getReferList();
              }
            } else {
              // 接口错误提示
              LS.ui.toastShowHandle(res.error.message);
              // 上报
              inviteFn.inpEmailErrorReport(res.error.message);
            }
            fristSend = true;
            LS.ui.loadingBtnHide($('.ls-send-email'));
          },
          error: function (error) {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            fristSend = true;
            LS.ui.loadingBtnHide($('.ls-send-email'));
            // 上报
            inviteFn.inpEmailErrorReport(LS.ui.errorMsgMap.baseError);
          }
        });
      })
      
    },

    /**
     * 
     * 输入邮箱错误上报
     */
    inpEmailErrorReport: function (text) {
      // 上报
      LS.stat({
        eid: LS.ui.reportType['custom'],
        ext1: LS.ui.referReportMap['customrReferSendEmailError'],
        ext2: text,
      });
    },

    /**
     * 功能上报方法
     */
    reportHandle: function (reportType, ext1, data = {}) {
      // 上报
      LS.stat({
        eid: reportType,
        ext1: ext1,
        ...data
      });
    },

    /**
     * 个人中心推荐好友模块方法
     */
    myCenterReferFriendHandle: function () {
      // 添加到页面
      $(".my-refer-friend-wrapper").html(referFriendPageHtml);
      $('.my-refer-friend-wrapper').show().siblings('.my-module').hide();
      // 请求
      if (LS.ui.isLogin()) {
        var userEmail = LS.userVipInfo.userBasicInfo.email || ''; 
        if (userEmail) {
          $('.inviter-email-inp').val(userEmail).addClass('disabled');
        }
        $('.refer-link-box').show();
        $('.box-referrals').show();
        inviteFn.getReferList(true);
        // 调用滚动方法
        inviteFn.getReferScroll();
      }
      // 事件集合方法
      inviteFn.bindEvent();
      // 上报
      LS.stat({
        eid: LS.ui.reportType['moduleShow'],
        ext1: LS.ui.referReportMap['showRefer'],
      });
    }

  }

  // 初始化方法
  function init() {
    if ((location.href.indexOf("pages/refer") > 0 && location.href.indexOf("jumpUrl") < 0)) {
      var inviterEmail = LS.getParam('inviterEmail') || '';
      if (LS.ui.isLogin()) {
        inviterEmail = LS.userVipInfo.userBasicInfo.email || '';
        $('.refer-link-box').show();
        $('.box-referrals').show();
        $('.inviter-email-inp').addClass('disabled');
        inviteFn.getReferList();
        inviteFn.getReferScroll();
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.referReportMap['showRefer'],
        });
      } else {
        $('.send-inp-box .tip').show();
      }
      if (inviterEmail) {
        $('.inviter-email-inp').val(inviterEmail);
      }
      $('.looksky-invite-mobile-page').empty();
      inviteFn.bindEvent();
    }
  }
  
  init();

  LS.ui.inviteFn = {
		myCenterReferFriendHandle: inviteFn.myCenterReferFriendHandle
	};

})();